import * as React from "react";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  Alert,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  ListItemButton,
  Select,
  Stack,
  TextField,
  useMediaQuery,
} from "@mui/material";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import {
  ContentState,
  convertFromHTML,
  EditorState,
  convertFromRaw,
  convertToRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { Toolbar } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateToHTML } from "draft-js-export-html";
import GenerateLessonMessage from "./GenerateLessonMessage";
import WelcomeDialog from "./Helper/WelcomeDialog";
import LoadingComponent from "../LoadingComponents/LoadingComponent";
import AdditionalResourcesCheckbox from "../Boost/AdditionalResourcesCheckbox";
function generate(element) {
  return [0, 1, 2].map((value) =>
    React.cloneElement(element, {
      key: value,
    })
  );
}

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

function FormFields(value) {
  if (value === 1) {
    return (
      <>
        <TextField id="outlined-basic" label="Grade Level" variant="outlined" />
        <TextField id="outlined-basic" label="Subject" variant="outlined" />
        <TextField
          id="outlined-basic"
          label="Textbook Title"
          variant="outlined"
        />
        <TextField
          id="outlined-basic"
          label="Textbook Author"
          variant="outlined"
        />
        <TextField
          id="outlined-basic"
          label="Year Published"
          variant="outlined"
        />
        <TextField
          id="outlined-basic"
          label="Textbook ISBN#"
          variant="outlined"
        />
        <TextField id="outlined-basic" label="State" variant="outlined" />
      </>
    );
  }
  return (
    <>
      <Typography>Under review</Typography>
    </>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const htmlString =
  "<h1>Here the Lesson will be generated, and you can edit your Lesson before extraction</h1>";
const blocksFromHtml = convertFromHTML(htmlString);
const content = ContentState.createFromBlockArray(
  blocksFromHtml.contentBlocks,
  blocksFromHtml.entityMap
);
const editorState = EditorState.createWithContent(content);

function HomeLessonList({ payment }) {
  const isMobile = useMediaQuery("(max-width:600px)");

  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [age, setAge] = React.useState("");
  const [selected_lesson, set_selected_lesson] = React.useState(-1);
  const [planeData, setPlaneData] = useState(null);
  const [lessonsData, setLessonsData] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [lesson_params, set_lesson_params] = useState({});
  const [generating_lesson, set_generating_lesson] = useState(false);
  const [start_free_trial, set_start_free_trial] = useState(false);
  const [already_used_trial, set_already_used_trial] = useState(false);
  const [loading_templates, set_loading_templates] = useState(true);
  const [templates, setTemplates] = useState([]);
  const navigator = useNavigate();
  const [selected_template, set_selected_template] = React.useState(-1);
  const [open_delete_template, set_open_delete_template] =
    React.useState(false);
  const [openAddTemplate, setOpen_AddTemplate] = React.useState(false);
  const [generating_template, set_generating_template] = useState(false);
  const [template_selected, set_template_selected] = React.useState("");
  const [error_select_template, set_error_select_template] = useState(false);
  const [error_lesson_module, set_error_lesson_module] = useState(false);
  const [selected_download_type, set_selected_download_type] = useState(0);
  const [selected_additional_resource, set_selected_additional_resource] =
    useState(0);
  const [generate_additional_resource, set_generate_additional_resource] =
    useState(false);
  let payment_done = payment;
  const [show_payment_alert, set_payment_alert] = useState(false);
  const [open_delete_lesson, set_delete_lesson] = useState(false);
  const [removing_lesson_progress, set_removing_lesson_progress] =
    useState(false);
  const [custom_checked, set_custom_checked] = useState(false);
  const [grade_level, set_grade_level] = useState("1");
  const [error_template, set_errorTemplate] = useState([]);
  const [EmptyGenerateLessonField, setEmptyGenerateLessonField] = useState({});
  const [Tabvalue, setTabValue] = React.useState(0);
  const [state, setState] = useState(editorState);
  const [usedFreeTrial, setUsedFreeTrial] = useState(false);
  const [openUsedFreeTrial_dialog, setOpenUsedFreeTrial_dialog] =
    useState(false);
  const [show_welcome_message, set_show_welcome_message] = useState(false);

  const [lessonTime, setLessonTime] = useState("45 minutes");

  const [lessonSubject, setLessonSubject] = useState("History");

  const [additional_selected_resources, setAdditional_selected_resources] =
    useState([]);
  const [isMobileEditor, setIsMobileEditor] = useState(false);

  const onEditorStateChange = (newState) => {
    setState(newState);
  };

  function saveHtml() {
    const blocks = state.getCurrentContent().getBlocksAsArray();
    const contentState = ContentState.createFromBlockArray(blocks);
    const html = stateToHTML(contentState);
    //console.log(html);
    return html;
  }

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchData = async () => {
    const response = await fetch(
      "https://ailessonplan.com/core/api/active_plane",
      {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    const data = await response.json();
    //console.log('data', data);
    if (data.hasOwnProperty("message")) {
      //set_start_free_trial(true)
      return;
    }
    setPlaneData(data);
    //console.log(data);
    if (data.plane_name === "trial") {
      set_show_welcome_message(true);
    }
    if (data.finished === 1) {
      set_open_sub_end(true);
    }
  };

  useEffect(() => {
    fetchData();

    const fetchData2 = async () => {
      const response = await fetch(
        "https://ailessonplan.com/core/api/my_lessons",
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const data = await response.json();
      setLessonsData(data);
      //console.log('Type of the planeData = ', typeof(lessonsData));
    };
    fetchData2();

    const fetchData_trial = async () => {
      try {
        const response = await fetch(
          "https://ailessonplan.com/core/api/used_free_trial",
          {
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        const data = await response.json();
        setUsedFreeTrial(data.used);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData_trial();

    if (payment_done !== undefined) {
      set_payment_alert(true);
    }

    const timeoutId = setTimeout(() => {
      // code to be executed after 5 seconds
      set_payment_alert(false);
    }, 5000);
    return () => clearTimeout(timeoutId);
    /*if (payment_done !== null && payment_done !== undefined) {
            set_payment_alert(true);
            console.log('Yes payment work: ', payment_done);
        }
        else {
            console.log("Yes undefine payment: ", payment_done);
        }*/
  }, [token]);

  const handleClickOpen_addLesson = () => {
    if (planeData === null && usedFreeTrial) {
      setOpenUsedFreeTrial_dialog(true);
      return;
    } else if (planeData === null && !usedFreeTrial) {
      set_start_free_trial(true);
      return;
    }
    if (planeData.finished === 1) {
      set_open_sub_end(true);
      return;
    }
    setOpen(true);
  };

  const handleClose_addLesson = (event, reason) => {
    if (reason && reason == "backdropClick" && generating_lesson) return;
    set_error_select_template(false);
    set_error_lesson_module(false);
    setOpen(false);
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  function lesson_content(id) {
    if (lessonsData === null) return "";
    for (let i = 0; i < lessonsData.length; i++) {
      let lesson = lessonsData[i];
      if (lesson.id === id) {
        return lesson.lesson;
      }
    }
    return "";
  }

  function lesson_content_array(id) {
    let data = lesson_content(id);
    let arr = data.split("\n");
    return data.split("\n");
  }

  function lesson_content_html(id) {
    /*if (lessonsData === null)
            return "";
        let html = "";
        let lesson1 = null;
        for (let i = 0; i < lessonsData.length; i++) {
            let lesson = lessonsData[i];
            if (lesson.id === id) {
                html = lesson.lesson;
                lesson1 = lesson;
                break;
            }
        }
        if (lesson1 === null)
            return "";
        let arr = html.split('\n');
        let final_html = "";
        for (var i = 0; i < arr.length; i++) {
            final_html += arr[i] + "<br>";
        }
        html = "<b><h6 style=\"text-align: center;\">" + lesson1.title + "</h6></b>" + "<br>" + final_html;
        return html;*/

    if (lessonsData === null) return "";
    let html = "";
    let lesson1 = null;
    for (let i = 0; i < lessonsData.length; i++) {
      let lesson = lessonsData[i];
      if (lesson.id === id) {
        html = lesson.lesson;
        lesson1 = lesson;
        break;
      }
    }
    if (lesson1 === null) return "";
    return html;
  }

  function containsHTMLTags(str) {
    // Regular expression to match HTML tags
    const htmlTagPattern = /<[^>]*>/;

    // Test the string against the regular expression
    return htmlTagPattern.test(str);
  }

  function parseStyleTag(html) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(html, 'text/html');

    // Select all the style tags in the HTML
    let styleTags = doc.getElementsByTagName('style');

    // Iterate over each style tag
    for (let styleTag of styleTags) {
      let cssText = styleTag.textContent;
      let rules = cssText.split('}');

      // For each rule in the CSS
      for (let rule of rules) {
        let ruleParts = rule.split('{');

        if (ruleParts.length === 2) {
          let selector = ruleParts[0].trim();
          let styles = ruleParts[1].trim();

          // Select all the elements in the HTML that match the selector
          let elements = doc.querySelectorAll(selector);

          // For each selected element
          for (let element of elements) {
            // Split the styles by ';' and add each style to the element's inline style attribute
            let styleAttrs = styles.split(';');
            for (let styleAttr of styleAttrs) {
              let attrParts = styleAttr.split(':');
              if (attrParts.length === 2) {
                let attrName = attrParts[0].trim();
                let attrValue = attrParts[1].trim();
                element.style[attrName] = attrValue;
              }
            }
          }
        }
      }

      // Remove the style tag from the HTML
      styleTag.parentNode.removeChild(styleTag);
    }

    // Return the HTML with the style tag content converted into inline style attributes
    return doc.documentElement.innerHTML;
  }

  const [htmlContent, setHtmlContent] = useState('');
  const [isTable, setIsTable] = useState(false);
  function lesson_content_state(id) {
    let htmlString = lesson_content_html(id);
    if (containsHTMLTags(htmlString)) {
      setHtmlContent(htmlString);
      setIsTable(true);
      const contentState = ContentState.createFromText(htmlString);
      setState(EditorState.createWithContent(contentState));
    } else {
      const contentState = ContentState.createFromText(htmlString);
      setState(EditorState.createWithContent(contentState));
      setIsTable(false);
    }
  }

  function get_variable_based_on_selectedLesson() {
    if (age === 12) {
      return (
        <>
          <Stack spacing={2}>
            <Stack direction={"row"} spacing={1}>
              <TextField
                id="pages"
                label="Pages"
                variant="outlined"
                onChange={handle_textChange}
                error={EmptyGenerateLessonField.hasOwnProperty("pages")}
                helperText={
                  EmptyGenerateLessonField.hasOwnProperty("pages")
                    ? "This field is required"
                    : ""
                }
              ></TextField>
              <TextField
                id="minutes"
                label="Minutes"
                variant="outlined"
                onChange={handle_textChange}
                error={EmptyGenerateLessonField.hasOwnProperty("minutes")}
                helperText={
                  EmptyGenerateLessonField.hasOwnProperty("minutes")
                    ? "This field is required"
                    : ""
                }
              ></TextField>
              <TextField
                id="topic"
                label="Topic"
                variant="outlined"
                onChange={handle_textChange}
                error={EmptyGenerateLessonField.hasOwnProperty("topic")}
                helperText={
                  EmptyGenerateLessonField.hasOwnProperty("topic")
                    ? "This field is required"
                    : ""
                }
              ></TextField>
            </Stack>

            <TextField
              id="plan"
              label="Your Lesson Plan"
              placeholder="Here goes your lesson generated or created by you..."
              multiline
              rows={5}
              onChange={handle_textChange}
              error={EmptyGenerateLessonField.hasOwnProperty("plan")}
              helperText={
                EmptyGenerateLessonField.hasOwnProperty("plan")
                  ? "This field is required"
                  : ""
              }
            />
          </Stack>
        </>
      );
    }
    return (
      <>
        <TextField
          id="pages"
          label="Pages"
          variant="outlined"
          onChange={handle_textChange}
          error={EmptyGenerateLessonField.hasOwnProperty("pages")}
          helperText={
            EmptyGenerateLessonField.hasOwnProperty("pages")
              ? "This field is required"
              : ""
          }
        ></TextField>
        <TextField
          id="minutes"
          label="Minutes"
          variant="outlined"
          onChange={handle_textChange}
          error={EmptyGenerateLessonField.hasOwnProperty("minutes")}
          helperText={
            EmptyGenerateLessonField.hasOwnProperty("minutes")
              ? "This field is required"
              : ""
          }
        ></TextField>
        <TextField
          id="topic"
          label="Topic"
          variant="outlined"
          onChange={handle_textChange}
          error={EmptyGenerateLessonField.hasOwnProperty("topic")}
          helperText={
            EmptyGenerateLessonField.hasOwnProperty("topic")
              ? "This field is required"
              : ""
          }
        ></TextField>
      </>
    );
  }

  function CustomModuleChecker() {
    let keyword = "topic";
    if (!lesson_params.hasOwnProperty(keyword)) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    if (lesson_params[keyword].length === 0) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    keyword = "subject";
    if (!lesson_params.hasOwnProperty(keyword)) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    if (lesson_params[keyword].length === 0) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    keyword = "lesson_time";
    if (!lesson_params.hasOwnProperty(keyword)) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    if (lesson_params[keyword].length === 0) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    keyword = "grade_level";
    if (!lesson_params.hasOwnProperty(keyword)) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    if (lesson_params[keyword].length === 0) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    keyword = "lesson_objective";
    if (!lesson_params.hasOwnProperty(keyword)) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    if (lesson_params[keyword].length === 0) {
      let error_js = { [keyword]: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    return true;
  }

  function titleChecker() {
    if (!lesson_params.hasOwnProperty("title")) {
      let error_js = { title: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    if (lesson_params["title"].length === 0) {
      let error_js = { title: true };
      setEmptyGenerateLessonField(error_js);
      return false;
    }
    return true;
  }

  function handle_on_submit_new_lesson() {
    /*let ans = {};
        //console.log(L_title[0], " = ", L_title[1]);
        let a = L_title[0];
        let b = L_title[1];
        ans = {...ans, a : b}*/
    if (!titleChecker()) return;
    //console.log("ERROR: ", EmptyGenerateLessonField);
    //return;
    //const body = JSON.stringify(lesson_params);
    let j = lesson_params;
    if (!lesson_params.hasOwnProperty("grade_level")) {
      j["grade_level"] = "1";
      set_lesson_params({ ...lesson_params, grade_level: "1" });
    }
    if (!lesson_params.hasOwnProperty("lesson_objective")) {
      j["lesson_objective"] = "";
      set_lesson_params({ ...lesson_params, lesson_objective: "" });
    }
    if (!lesson_params.hasOwnProperty("lesson_time")) {
      j["lesson_time"] = "45 minutes";
      set_lesson_params({ ...lesson_params, lesson_time: "45 minutes" });
    }
    if (!lesson_params.hasOwnProperty("subject")) {
      j["subject"] = "History";
      set_lesson_params({ ...lesson_params, subject: "History" });
    }
    if (!CustomModuleChecker()) {
      console.log(EmptyGenerateLessonField);
      return;
    }
    var add_size = additional_selected_resources.length;
    var R1 = "",
      R2 = "",
      R3 = "";
    var module_choosed = "14";
    if (add_size >= 1) {
      R1 = additional_selected_resources[0];
      module_choosed = "15";
    }
    if (add_size >= 2) {
      R2 = additional_selected_resources[1];
      module_choosed = "16";
    }
    if (add_size >= 3) {
      R3 = additional_selected_resources[2];
      module_choosed = "17";
    }

    //if (body.includes("grade level"))
    j["R1"] = R1;
    j["R2"] = R2;
    j["R3"] = R3;
    const body = JSON.stringify(j);
    console.log(body);
    //return;

    set_generating_lesson(true);

    const url = "https://ailessonplan.com/core/api/new_lesson";
    const headers = {
      Accept: "application/json",
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    };
    const data = {
      title: lesson_params["title"],
      params: body,
      module: module_choosed,
    };
    const options = {
      method: "POST",
      headers: headers,
      body: new URLSearchParams(data),
    };
    fetch(url, options)
      .then((response) => response.text())
      .then((result) => finish_generating_lesson(result))
      .catch((error) => console.log(error));
  }

  async function finish_generating_lesson(result) {
    //console.log('the result = ', result);
    let j = JSON.parse(result);
    if (j.hasOwnProperty("message")) {
      set_generating_lesson(false);
      open_sub_end(true);
      return;
    }
    let newLessonData = [...lessonsData, j];
    setLessonsData(newLessonData);
    //setLessonsData({...lessonsData, j})
    //console.log('lessondata after = ', lessonsData);
    set_generating_lesson(false);
    setOpen(false);
    set_lesson_params({});
    await fetchData();
    set_selected_lesson(j.id);
    lesson_content_state(j.id);
  }

  const handle_textChange = (event) => {
    const { id, value } = event.target;
    set_lesson_params({ ...lesson_params, [id]: value });
    setEmptyGenerateLessonField({});
  };

  const handle_GradeLevel = (event) => {
    set_grade_level(event.target.value);
    set_lesson_params({ ...lesson_params, grade_level: event.target.value });
  };

  const handle_LessonSubject = (event) => {
    setLessonSubject(event.target.value);
    set_lesson_params({ ...lesson_params, subject: event.target.value });
  };

  const handle_LessonTime = (event) => {
    setLessonTime(event.target.value);
    set_lesson_params({ ...lesson_params, lesson_time: event.target.value });
  };

  const [open_sub_end, set_open_sub_end] = React.useState(false);

  const handleClickOpen_sub_end = () => {
    set_open_sub_end(true);
  };

  const handleClose_sub_end = () => {
    set_open_sub_end(false);
  };

  const handleClickOpen_StartFreeTrial = () => {
    set_start_free_trial(true);
  };

  const handleClose_StartFreeTrial = () => {
    set_start_free_trial(false);
  };

  function StartActiveTrial() {
    fetch("https://ailessonplan.com/core/api/active_trial", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((data) => parse_active_free_trial(data))
      .catch((error) => console.error(error));
  }

  function parse_active_free_trial(data) {
    console.log("active trial: ", data);
    if (data.hasOwnProperty("message")) {
      //set_start_free_trial(true)
      set_already_used_trial(true);
      return;
    }
    set_start_free_trial(false);
    setPlaneData(data);
  }

  async function fetchTemplates() {
    const response = await fetch(
      "https://ailessonplan.com/core/api/my_templates",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    const data = await response.json();
    return data;
  }

  async function deleteTemplate(id) {
    const response = await fetch(
      "https://ailessonplan.com/core/api/remove_template",
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${encodeURIComponent(id)}`,
      }
    );
    const data = await response.json();
    return data;
  }

  async function deleteAndRemoveTemplate(id) {
    try {
      const response = await deleteTemplate(id);
      if (response.message === "done") {
        set_selected_template(-1);
        setTemplates(templates.filter((template) => template.id !== id));
      } else {
        //setErrorMessage(response.message);
      }
    } catch (error) {
      console.error(error);
      //setErrorMessage('An error occurred while deleting the template.');
    }
    set_open_delete_template(false);
  }

  async function addTemplate(name, template) {
    if (!template.hasOwnProperty("grade level")) {
      template["grade level"] = "1";
    }
    if (name === undefined) name = "";
    const response = await fetch(
      "https://ailessonplan.com/core/api/new_template",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `name=${encodeURIComponent(name)}&template=${encodeURIComponent(
          JSON.stringify(template)
        )}`,
      }
    );
    //console.log("Title: ", name);
    const data = await response.json();
    return data;
  }

  async function addNewTemplate() {
    try {
      const response = await addTemplate(lesson_params["title"], lesson_params);
      //console.log("adding new temp response: ", JSON.stringify(response));
      if (response.hasOwnProperty("errors")) {
        set_errorTemplate(response);
        return;
      }
      setTemplates([...templates, response]);
      set_lesson_params({});
    } catch (error) {
      console.error(error);
      //setErrorMessage('An error occurred while adding the template.');
    }
    setOpen_AddTemplate(false);
  }

  function selected_template_item() {
    for (var i = 0; i < templates.length; i++) {
      if (templates[i].id === selected_template) return templates[i];
    }
    return null;
  }

  function template_selected_inside_dropdown_menu() {
    for (var i = 0; i < templates.length; i++) {
      if (templates[i].id === template_selected) return templates[i];
    }
    return null;
  }

  function onClick_download() {
    const lessonId = selected_lesson;
    var type = "pdf";
    if (selected_download_type === 1) {
      type = "docx";
    }
    const url = `https://ailessonplan.com/core/api/download_lesson?id=${lessonId}&type=${type}`;

    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          // If the response is a successful download, we can create a new Blob
          // object from the response's binary data and use the URL.createObjectURL
          // method to create a URL that we can use to initiate a download on the client-side
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            if (type === "pdf") link.download = `lesson-${lessonId}.pdf`;
            else if (type === "docx") link.download = `lesson-${lessonId}.docx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
        } else {
          // If the response is an error, we can handle it here
          throw new Error(`Failed to download lesson: ${response.statusText}`);
        }
      })
      .catch((error) => {
        console.error(error);
        // Handle any errors that occur during the fetch request
      });
  }

  const addLesson_resource = () => {
    if (generate_additional_resource) return;
    set_generate_additional_resource(true);
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        lesson_id: selected_lesson,
        add_id: selected_additional_resource,
      }),
    };

    fetch("https://ailessonplan.com/core/api/add_lesson", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // update LessonData array
        const updatedLessonData = lessonsData.map((lesson) => {
          if (lesson.id === result.id) {
            return {
              ...lesson,
              plane_id: result.plane_id,
              title: result.title,
              module: result.module,
              params: result.params,
              lesson: result.lesson,
              token_used: result.token_used,
              created_at: result.created_at,
              updated_at: result.updated_at,
            };
          } else {
            return lesson;
          }
        });

        setLessonsData(updatedLessonData);
        set_generate_additional_resource(false);
      })
      .catch((error) => console.log("error", error));
  };

  function get_lesson_index_by_id() {
    for (var i = 0; i < lessonsData.length; i++) {
      if (lessonsData[i].id === selected_lesson) {
        return i;
      }
    }
    return -1;
  }
  function deleteLesson(index) {
    const newLessonsData = [...lessonsData]; // create a copy of the original array
    newLessonsData.splice(index, 1); // remove the element at the given index
    set_selected_lesson(-1);
    setLessonsData(newLessonsData); // set the state with the updated array
  }
  function removeLesson() {
    set_removing_lesson_progress(true);
    fetch(
      "https://ailessonplan.com/core/api/remove_lesson?id=" + selected_lesson,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // handle the response data here
        console.log(data);
        deleteLesson(get_lesson_index_by_id());
        set_delete_lesson(false);
        set_removing_lesson_progress(false);
      })
      .catch((error) => {
        // handle errors here
        console.error(error);
      });
  }

  const handleWelcomeDialogClose = () => {
    set_show_welcome_message(false);
  };
  const toolbarStyle = {};

  return (
    <Box
      width={"100%"}
      height={"100%"}
      display={"flex"}
      justifyContent={"center"}
      minHeight={"93vh"}
      bgcolor="aliceblue"
    >
      {show_payment_alert ? (
        <>
          <Alert
            severity="success"
            sx={{ justifyContent: "center", flex: "display", minHeight: 50 }}
          >
            Thank you for the latest payment your plan has been activated!
          </Alert>
        </>
      ) : (
        <></>
      )}

      {/*<WelcomeDialog open={show_welcome_message} onClose={handleWelcomeDialogClose} />*/}
      {/*You already finished your free trial*/}
      <Dialog
        open={openUsedFreeTrial_dialog}
        onClose={() => {
          setOpenUsedFreeTrial_dialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"No Active Subscribtion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You currently do not have an active subscription. Please explore our
            plans to continue using AI-Lesson and generate more lessons!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenUsedFreeTrial_dialog(false);
            }}
            style={{ textTransform: "none" }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              navigator("/pricing");
            }}
            style={{ textTransform: "none" }}
            autoFocus
          >
            Check Now!
          </Button>
        </DialogActions>
      </Dialog>

      {/*delete confirmation of lesson*/}
      <Dialog
        open={open_delete_lesson}
        onClose={() => {
          set_delete_lesson(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Confirmation"}
        </DialogTitle>
        <DialogContent>
          {removing_lesson_progress ? (
            <>
              <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress />
                <Typography>
                  Please wait while generating the additional resources...
                </Typography>
              </Box>
            </>
          ) : (
            <>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete "
                {lessonsData == null || selected_lesson === -1
                  ? ""
                  : lessonsData[get_lesson_index_by_id()].title}
                " Lesson? Deleting lesson will not refund the lesson credit.
              </DialogContentText>
            </>
          )}
        </DialogContent>
        {removing_lesson_progress ? (
          <></>
        ) : (
          <DialogActions>
            <Button
              onClick={function () {
                set_delete_lesson(false);
              }}
            >
              No
            </Button>
            <Button
              onClick={function () {
                removeLesson();
              }}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {/*delete confirmation of template*/}
      <Dialog
        open={open_delete_template}
        onClose={() => {
          set_open_delete_template(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this template?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={function () {
              set_open_delete_template(false);
            }}
          >
            No
          </Button>
          <Button
            onClick={function () {
              deleteAndRemoveTemplate(selected_template);
            }}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/*Already used*/}
      <Dialog
        open={already_used_trial}
        onClose={() => {
          set_already_used_trial(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Already used"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You already used your free trial
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/*You did not start yet your free trial*/}
      <Dialog
        open={start_free_trial}
        onClose={handleClose_StartFreeTrial}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"No Active Subscribtion yet"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You did not start yet your free Trial, start Now so you can create
            lessons.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose_StartFreeTrial}
            style={{ textTransform: "none" }}
          >
            Close
          </Button>
          <Button
            onClick={StartActiveTrial}
            style={{ textTransform: "none" }}
            autoFocus
          >
            Free Trial Now!
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open_sub_end}
        onClose={handleClose_sub_end}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Your Subscribition has been finished"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please subscribe to one of our plane, so you can continue using the
            service.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose_sub_end}
            style={{ textTransform: "none" }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              navigator("/pricing");
              handleClose_sub_end();
            }}
            style={{ textTransform: "none" }}
            autoFocus
          >
            Subscribe Now!
          </Button>
        </DialogActions>
      </Dialog>

      {/*Lesson Dialog*/}
      <Dialog
        open={open}
        onClose={handleClose_addLesson}
        fullWidth={true}
        disableEscapeKeyDown={generating_lesson ? true : false}
      >
        <DialogTitle>
          <Typography align="center" fontSize={25}>
            New Lesson
          </Typography>
        </DialogTitle>
        <DialogContent>
          {error_select_template && (
            <Alert
              severity="error"
              onClose={() => {
                set_error_select_template(false);
              }}
            >
              Please choose a template first or create a new template
            </Alert>
          )}
          {error_lesson_module && (
            <Alert
              severity="error"
              onClose={() => {
                set_error_lesson_module(false);
              }}
            >
              Please choose a Lesson module First
            </Alert>
          )}
          {generating_lesson ? (
            <Box
              sx={{ display: "flex" }}
              justifyContent={"center"}
              alignItems="center"
            >
              <Stack spacing={2} justifyContent={"center"} alignItems="center">
                <CircularProgress />
                <GenerateLessonMessage />
              </Stack>
            </Box>
          ) : (
            <>
              <Grid item xs={12} marginBottom={2} marginTop={2}>
                <TextField
                  id="title"
                  label="Lesson Name (only for you)"
                  variant="outlined"
                  fullWidth
                  onChange={handle_textChange}
                  error={EmptyGenerateLessonField.hasOwnProperty("title")}
                  helperText={
                    EmptyGenerateLessonField.hasOwnProperty("title")
                      ? "Please enter a valid Lesson Name"
                      : ""
                  }
                />
              </Grid>
              <FormControl
                margin={"dense"}
                fullWidth={true}
                sx={{ "& > *": { marginBottom: "1rem" } }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      id="topic"
                      label="Lesson Topic"
                      variant="outlined"
                      fullWidth
                      onChange={handle_textChange}
                      error={EmptyGenerateLessonField.hasOwnProperty("topic")}
                      helperText={
                        EmptyGenerateLessonField.hasOwnProperty("topic")
                          ? "This field is required"
                          : ""
                      }
                    />
                  </Grid>

                  {/* Grade Level Dropdown */}
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Grade Level
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="grade level"
                        value={grade_level}
                        label="Grade Level"
                        onChange={handle_GradeLevel}
                      >
                        <MenuItem value={1}>Grade 1</MenuItem>
                        <MenuItem value={2}>Grade 2</MenuItem>
                        <MenuItem value={3}>Grade 3</MenuItem>
                        <MenuItem value={4}>Grade 4</MenuItem>
                        <MenuItem value={5}>Grade 5</MenuItem>
                        <MenuItem value={6}>Grade 6</MenuItem>
                        <MenuItem value={7}>Grade 7</MenuItem>
                        <MenuItem value={8}>Grade 8</MenuItem>
                        <MenuItem value={9}>Grade 9</MenuItem>
                        <MenuItem value={10}>Grade 10</MenuItem>
                        <MenuItem value={11}>Grade 11</MenuItem>
                        <MenuItem value={12}>Grade 12</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Subject Dropdown */}
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="subject-label">Subject</InputLabel>
                      <Select
                        label={"Subject"}
                        labelId="subject-label"
                        id="subject"
                        value={lessonSubject}
                        onChange={handle_LessonSubject}
                        error={EmptyGenerateLessonField.hasOwnProperty(
                          "subject"
                        )}
                      >
                        <MenuItem value="Mathematics">Mathematics</MenuItem>
                        <MenuItem value="Science">Science</MenuItem>
                        <MenuItem value="History">History</MenuItem>
                        <MenuItem value="Geography">Geography</MenuItem>
                        <MenuItem value="Language Arts">Language Arts</MenuItem>
                        <MenuItem value="English Literature">
                          English Literature
                        </MenuItem>
                        <MenuItem value="Physical Education">
                          Physical Education
                        </MenuItem>
                        <MenuItem value="Art">Art</MenuItem>
                        <MenuItem value="Music">Music</MenuItem>
                        <MenuItem value="Social Studies">
                          Social Studies
                        </MenuItem>
                        <MenuItem value="Biology">Biology</MenuItem>
                        <MenuItem value="Chemistry">Chemistry</MenuItem>
                        <MenuItem value="Physics">Physics</MenuItem>
                        <MenuItem value="Computer Science">
                          Computer Science
                        </MenuItem>
                        <MenuItem value="Economics">Economics</MenuItem>
                        <MenuItem value="Business Studies">
                          Business Studies
                        </MenuItem>
                        <MenuItem value="Psychology">Psychology</MenuItem>
                        <MenuItem value="Philosophy">Philosophy</MenuItem>
                        <MenuItem value="Environmental Science">
                          Environmental Science
                        </MenuItem>
                        <MenuItem value="Political Science">
                          Political Science
                        </MenuItem>
                        <MenuItem value="Foreign Language">
                          Foreign Language (e.g., French, Spanish)
                        </MenuItem>
                        <MenuItem value="Health Education">
                          Health Education
                        </MenuItem>
                      </Select>
                      {EmptyGenerateLessonField.hasOwnProperty("subject") && (
                        <FormHelperText>This field is required</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Lesson Time Dropdown */}
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="time-label">Lesson Time</InputLabel>
                      <Select
                        label={"Lesson Time"}
                        labelId="time-label"
                        id="time"
                        value={lessonTime}
                        onChange={handle_LessonTime}
                        error={EmptyGenerateLessonField.hasOwnProperty("time")}
                      >
                        <MenuItem value="45 minutes">45 minutes</MenuItem>
                        <MenuItem value="60 minutes">60 minutes</MenuItem>
                      </Select>
                      {EmptyGenerateLessonField.hasOwnProperty("time") && (
                        <FormHelperText>This field is required</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      id="lesson_objective"
                      label="Lesson Points (Details)"
                      multiline
                      rows={4}
                      placeholder={"Lesson main points and objective"}
                      defaultValue=""
                      sx={{ width: "100%" }}
                      onChange={handle_textChange}
                      error={EmptyGenerateLessonField.hasOwnProperty(
                        "lesson_objective"
                      )}
                      helperText={
                        EmptyGenerateLessonField.hasOwnProperty(
                          "lesson_objective"
                        )
                          ? "This field is required"
                          : ""
                      }
                    />
                  </Grid>

                  {/* Additional Resources Checkbox to fill parent width */}
                  <Grid item xs={12}>
                    <AdditionalResourcesCheckbox
                      selectedItems={additional_selected_resources}
                      setSelectedItems={setAdditional_selected_resources}
                    />
                  </Grid>
                </Grid>
              </FormControl>
            </>
          )}
        </DialogContent>

        <DialogActions>
          {generating_lesson ? (
            <></>
          ) : (
            <>
              <Button
                onClick={handleClose_addLesson}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handle_on_submit_new_lesson}
                style={{ textTransform: "none" }}
              >
                Generate Now
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      <Container maxWidth="xl" sx={{ bgcolor: "white" }}>
        {!isMobile && (
          <Grid container mt={4}>
            <Grid
              item
              md={4}
              sm={4}
              display={{ md: "block", sm: "block", xs: "none" }}
            >
              <Stack direction="row">
                {/* <SchoolIcon sx={{ ml: 2, }} size="medium" /> */}
                <Box
                  component="img"
                  src="/assets/images/lesson/lessonIcon.png"
                  alt=""
                  width={44}
                  height={37}
                  mt={1}
                />
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems={"flex-start"}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    fontSize={24}
                    sx={{ ml: 2 }}
                  >
                    My Content
                  </Typography>
                  {planeData && (
                    <Typography sx={{ ml: 2 }}>
                      {planeData.plane_name[0].toUpperCase() +
                        planeData.plane_name.slice(1)}{" "}
                      ({planeData.credit_used}/{planeData.total_credit})
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Grid>
            <Grid item md={4} sm={4} xs={12} display="flex" alignItems="center">
              <Button
                onClick={handleClickOpen_addLesson}
                variant="outlined"
                sx={{
                  textTransform: "none",
                  fontSize: 18,
                  px: 3,
                }}
              >
                + Add New Lessons
              </Button>
            </Grid>
            <Grid
              item
              md={4}
              sm={4}
              xs={12}
              display={{ md: "flex", sm: "flex", xs: "block" }}
              alignItems={"center"}
              justifyContent="flex-end"
              gap={1}
            >
              <Select
                labelId="download-type-label"
                id="download-type"
                value={selected_download_type}
                onChange={(event) => {
                  set_selected_download_type(event.target.value);
                }}
                sx={{ bgcolor: "#5375E2", color: "white" }}
                size="small"
              >
                <MenuItem value={0}>PDF (pdf)</MenuItem>
                <MenuItem value={1}>Word (docx)</MenuItem>
              </Select>
              <Button
                variant="outlined"
                color="primary"
                onClick={onClick_download}
              >
                <Box
                  component="img"
                  src="/assets/images/lesson/downloadIcon.png"
                  alt=""
                  height={30}
                  width={25}
                />
              </Button>
            </Grid>
          </Grid>
        )}

        {isMobile && (
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            mt={2}
          >
            <Button
              onClick={handleClickOpen_addLesson}
              variant="outlined"
              sx={{
                textTransform: "none",
                fontSize: 18,
                px: 3,
              }}
            >
              <AddIcon />
            </Button>
            <Select
              labelId="download-type-label"
              id="download-type"
              value={selected_download_type}
              onChange={(event) => {
                set_selected_download_type(event.target.value);
              }}
              sx={{ bgcolor: "#5375E2", color: "white" }}
              size="small"
            >
              <MenuItem value={0}>PDF (pdf)</MenuItem>
              <MenuItem value={1}>Word (docx)</MenuItem>
            </Select>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClick_download}
            >
              <Box
                component="img"
                src="/assets/images/lesson/downloadIcon.png"
                alt=""
                height={30}
                width={25}
              />
            </Button>
          </Stack>
        )}
        <Divider sx={{ mt: 1 }} />

        <Grid container mt={3}>
          {!isMobileEditor && (
            <Grid item md={4} xs={12}>
              <Stack
                height={"100%"}
                maxHeight="calc(80vh)"
                pr={{ md: 3, xs: 0 }}
              >
                <Demo sx={{ overflow: "auto", flexGrow: 1 }}>
                  <List dense={dense}>
                    {lessonsData &&
                      lessonsData.map((lesson) => (
                        <ListItemButton
                          key={lesson.id}
                          selected={selected_lesson === lesson.id}
                          onClick={() => {
                            if (isMobile === true) {
                              setIsMobileEditor(true);
                              set_selected_lesson(lesson.id);
                              lesson_content_state(lesson.id);
                            } else {
                              set_selected_lesson(lesson.id);
                              lesson_content_state(lesson.id);
                            }
                          }}
                          sx={{
                            color:
                              selected_lesson === lesson.id
                                ? "#29ADB2"
                                : "black",
                          }}
                        >
                          <ListItemAvatar>
                            <Box
                              width={40}
                              height={40}
                              border="1px solid rgba(41, 173, 178, 0.30)"
                              borderRadius="50%"
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                bgcolor: "rgba(41, 173, 178, 0.30)",
                              }}
                            >
                              {/* <CastForEducationIcon /> */}
                              <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.0851 12.8897C24.0851 15.2651 24.0844 17.6406 24.0851 20.016C24.0851 21.1505 23.6123 22.0012 22.5791 22.5063C22.1523 22.7154 21.6953 22.7894 21.2204 22.7291C18.4045 22.3698 15.6605 22.6558 13.007 23.6797C11.8201 24.1374 12.142 24.0806 11.0311 23.6617C8.49406 22.7054 5.8801 22.3748 3.18998 22.7032C2.1582 22.8289 1.26508 22.6278 0.582496 21.7964C0.186595 21.3136 0.0141513 20.7496 0.0148698 20.1273C0.0163068 18.4604 0.0155883 16.7927 0.0155883 15.1258C0.0155883 12.0599 0.0493585 8.99395 0.000499522 5.92877C-0.0217744 4.54491 0.698896 3.19626 2.55626 2.97424C2.79624 2.9455 3.03263 2.89017 3.27333 2.86574C3.42638 2.84994 3.46589 2.78168 3.46015 2.63941C3.44721 2.34338 3.46158 2.04951 3.54062 1.75995C3.86539 0.570808 4.9913 -0.148424 6.24439 0.026893C8.43658 0.333699 10.3284 1.24909 11.9041 2.80683C12.0299 2.93113 12.0974 2.93113 12.2224 2.80683C13.7902 1.25627 15.6742 0.346632 17.8549 0.0290486C19.3803 -0.192972 20.6563 0.881925 20.6686 2.42458C20.6693 2.47846 20.675 2.53307 20.6678 2.58552C20.6405 2.77305 20.7038 2.84994 20.9071 2.87365C21.2973 2.91963 21.6867 2.99148 22.0704 3.07699C23.197 3.32847 23.996 4.25751 24.0686 5.41431C24.0988 5.89644 24.0851 6.38215 24.0851 6.86571C24.0865 8.87396 24.0851 10.8822 24.0851 12.8897ZM12.9237 20.7934C13.0121 20.7201 13.0545 20.6878 13.094 20.6526C14.5296 19.3528 16.2023 18.5286 18.0999 18.1543C18.7221 18.0314 18.9477 17.7548 18.9477 17.116C18.9477 12.2589 18.9477 7.40101 18.9477 2.54385C18.9477 1.91515 18.656 1.65074 18.0381 1.74414C16.0909 2.03945 14.4455 2.90885 13.1005 4.35019C12.9682 4.49174 12.9194 4.63473 12.9201 4.82729C12.9251 10.043 12.9237 15.2594 12.9237 20.4751C12.9237 20.5627 12.9237 20.6497 12.9237 20.7934ZM11.2021 20.8049C11.2021 20.6368 11.2021 20.5398 11.2021 20.4428C11.2021 18.4625 11.2021 16.4816 11.2021 14.5014C11.2021 11.2666 11.2021 8.03114 11.2021 4.79639C11.2021 4.67353 11.2108 4.55784 11.1116 4.44791C9.73852 2.92322 8.04139 2.00784 6.008 1.73193C5.47199 1.65936 5.17955 1.94317 5.17883 2.48852C5.17811 7.38161 5.17811 12.274 5.17883 17.1671C5.17883 17.721 5.44253 18.0343 5.98644 18.1342C7.0247 18.3239 8.0069 18.6731 8.9381 19.1681C9.74787 19.5985 10.4822 20.1345 11.2021 20.8049ZM9.01714 21.2583C8.83751 21.1368 8.72326 21.0549 8.60471 20.9795C7.70225 20.4076 6.72292 20.0361 5.6782 19.8191C4.23111 19.518 3.45871 18.5559 3.45871 17.0873C3.45871 13.0378 3.45871 8.9882 3.45871 4.93866C3.45871 4.87615 3.45224 4.8122 3.46015 4.75041C3.47811 4.60239 3.41488 4.56144 3.27549 4.58802C3.02042 4.63616 2.76247 4.6685 2.50883 4.72095C1.98935 4.82801 1.73859 5.13337 1.73859 5.66148C1.73715 10.4727 1.73715 15.2838 1.73859 20.095C1.73859 20.7323 2.17185 21.0916 2.80917 21.0111C4.39924 20.8106 5.98932 20.8042 7.57723 21.0298C8.03133 21.093 8.48472 21.1728 9.01714 21.2583ZM15.1353 21.2417C15.2136 21.2489 15.2316 21.2547 15.2481 21.2511C17.229 20.8272 19.2243 20.7611 21.2333 20.9967C22.0266 21.0901 22.3894 20.7647 22.3894 19.9642C22.3894 15.2515 22.3894 10.5388 22.3894 5.8253C22.3894 5.74483 22.3908 5.66364 22.3872 5.58316C22.3686 5.15708 22.1013 4.83519 21.6845 4.74825C21.4568 4.70083 21.2261 4.66778 20.9962 4.63113C20.6678 4.5794 20.6671 4.58012 20.6671 4.90201C20.6671 8.98748 20.6678 13.0737 20.6664 17.1591C20.6657 18.5322 19.8466 19.5324 18.5073 19.8097C18.2709 19.8586 18.0338 19.9089 17.8017 19.9728C16.8554 20.2351 15.9767 20.6396 15.1353 21.2417Z"
                                  fill="#29ADB2"
                                />
                              </svg>
                            </Box>
                          </ListItemAvatar>
                          <ListItemText
                            primary={lesson.title}
                            secondary={secondary ? "Secondary text" : null}
                          />
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                              set_delete_lesson(true);
                            }}
                          >
                            {/* <DeleteIcon /> */}
                            <Box
                              width={20}
                              height={22.5}
                              component="img"
                              src="/assets/images/lesson/Vector.png"
                              alt=""
                            />
                          </IconButton>
                        </ListItemButton>
                      ))}
                  </List>
                </Demo>
              </Stack>
            </Grid>
          )}
          {isMobileEditor && (
            <Stack>
              <Button
                onClick={() => {
                  setIsMobileEditor(false);
                  navigator("/lessons");
                }}
                variant="outlined"
              >
                Previous Page
              </Button>
              <br />
              <Box border="1px solid #ccc" borderRadius={2}>
                <Editor
                  toolbar={{
                    //options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'remove', 'history', 'image'],
                    options: [
                      "inline",
                      "blockType",
                      "fontSize",
                      "fontFamily",
                      "list",
                      "textAlign",
                      "remove",
                      "history",
                    ],
                    inline: { inDropdown: true },
                    list: { inDropdown: true },
                    textAlign: { inDropdown: true },
                    link: { inDropdown: false },
                    history: { inDropdown: true },
                  }}
                  editorState={state}
                  onEditorStateChange={onEditorStateChange}
                />
                {/* <TextField
                  sx={{ m: 1 }}
                  placeholder="Regenerate content"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            d="M13.4971 18.1351L21.4365 9.96203M29.5582 4.97416L22.8565 27.3955C22.2559 29.4049 21.9554 30.4101 21.4374 30.7432C20.9881 31.0322 20.4318 31.0806 19.9424 30.8715C19.3782 30.6305 18.9202 29.6893 18.0066 27.8083L13.7619 19.069C13.6169 18.7705 13.5443 18.6219 13.4475 18.4926C13.3615 18.3778 13.2624 18.2744 13.1509 18.1859C13.0281 18.0885 12.8861 18.0154 12.6091 17.8729L4.10005 13.4932C2.27284 12.5527 1.35916 12.082 1.12503 11.5011C0.921984 10.9974 0.968291 10.4242 1.24902 9.96166C1.57273 9.42833 2.54909 9.1185 4.50162 8.50004L26.2821 1.60115C27.8172 1.11494 28.585 0.872026 29.1035 1.06797C29.5551 1.23865 29.9111 1.60481 30.0769 2.06972C30.2671 2.6032 30.031 3.39321 29.5592 4.97183L29.5582 4.97416Z"
                            stroke="#5375E2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                /> */}
              </Box>
            </Stack>
          )}
          <Grid item md={8} xs={12}>
            <Stack
              bgcolor={"white"}
              height={"100%"}
              maxHeight="calc(80vh)"
              borderRadius={"10px"}
            >
              {generate_additional_resource ? (
                <LoadingComponent />
              ) : (
                <>
                  <Box
                      display={{md: "block", sm: "none", xs: "none"}}
                      sx={{
                        height: "calc(100%)",
                        overflow: "auto",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        p: 2,
                      }}
                  >
                    <div>
                      {isTable ? (
                          <div dangerouslySetInnerHTML={{__html: htmlContent}}/>
                      ) : (
                          <Editor
                              toolbar={{
                                //options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'remove', 'history', 'image'],
                                options: [
                                  "inline",
                                  "blockType",
                                  "fontSize",
                                  "fontFamily",
                                  "list",
                                  "textAlign",
                                  "remove",
                                  "history",
                                ],
                                inline: {inDropdown: true},
                                list: {inDropdown: true},
                                textAlign: {inDropdown: true},
                                link: {inDropdown: false},
                                history: {inDropdown: true},
                              }}
                              editorState={state}
                              toolbarStyle={toolbarStyle}
                              onEditorStateChange={onEditorStateChange}
                          />
                      )}
                    </div>

                    {/* {selected_lesson === -1 ? (
                      false
                    ) : (
                      <TextField
                        sx={{ m: 1 }}
                        placeholder="Regenerate content"
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                              >
                                <path
                                  d="M13.4971 18.1351L21.4365 9.96203M29.5582 4.97416L22.8565 27.3955C22.2559 29.4049 21.9554 30.4101 21.4374 30.7432C20.9881 31.0322 20.4318 31.0806 19.9424 30.8715C19.3782 30.6305 18.9202 29.6893 18.0066 27.8083L13.7619 19.069C13.6169 18.7705 13.5443 18.6219 13.4475 18.4926C13.3615 18.3778 13.2624 18.2744 13.1509 18.1859C13.0281 18.0885 12.8861 18.0154 12.6091 17.8729L4.10005 13.4932C2.27284 12.5527 1.35916 12.082 1.12503 11.5011C0.921984 10.9974 0.968291 10.4242 1.24902 9.96166C1.57273 9.42833 2.54909 9.1185 4.50162 8.50004L26.2821 1.60115C27.8172 1.11494 28.585 0.872026 29.1035 1.06797C29.5551 1.23865 29.9111 1.60481 30.0769 2.06972C30.2671 2.6032 30.031 3.39321 29.5592 4.97183L29.5582 4.97416Z"
                                  stroke="#5375E2"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                      />
                    )} */}
                  </Box>
                </>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HomeLessonList;
